// extracted by mini-css-extract-plugin
export default {"productGallery":"OK-z","inQuickShop":"PK-z"};